import * as React from 'react';
import Icon from '@common/components/icon';
import { PerformanceQuestionType } from '@modules/performance/definitions';
import { combineClassNames } from '@common/utils/combineClassNames';

type Props = {
  type: string,
  className?: string,
};

export const QuestionIcon = ({ type, className }: Props) => {

  const customClass = 'tw-p-1 !tw-h-4 !tw-w-4 tw-text-white tw-rounded-[4px]';


  switch (type) {
    case PerformanceQuestionType.OPEN_QUESTION:
      return <Icon type="chat_default" className={combineClassNames(customClass, 'tw-bg-red-400', className)} />;
    case PerformanceQuestionType.COMPETENCIES:
      return <Icon type="briefcase_job" className={combineClassNames(customClass, 'tw-bg-purple-400', className)} />;
    case PerformanceQuestionType.SLIDER:
      return <Icon type="slider_long" className={combineClassNames(customClass, 'tw-bg-green-400', className)} />;
    case PerformanceQuestionType.CONTENT_MODULE:
      return <Icon type="list_long" className={combineClassNames(customClass, 'tw-bg-blue-400', className)} />;
      case PerformanceQuestionType.TALENT_REVIEW:
        return <Icon type="star__filled" className={combineClassNames(customClass, 'tw-bg-yellow-400', className)} />;
    case PerformanceQuestionType.GOAL:
      return <Icon type="flag" className={combineClassNames(customClass, 'tw-bg-orange-400', className)} />;
    default:
      return null;
  }
};
